export const LIST_CUSTOMER_PORTALS = "listCustomerPortals";
export const CREATE_CUSTOMER_PORTAL = "createCustomerPortal";
export const GET_CUSTOMER_PORTAL = "getCustomerPortal";
export const UPDATE_CUSTOMER_PORTAL = "updateCustomerPortal";
export const DELETE_CUSTOMER_PORTAL = "deleteCustomerPortal";
export const LIST_OWN_OEM_PORTAL_HISTORY = "listOwnOemPortalHistory";
